<template>
    <div class="ObjectMapPreview">
        <div class="ObjectMapPreview__id">
            ID {{id}}
        </div>
        <div class="ObjectsPreviewList">
            <div class="ObjectsPreviewList__name">{{name}}</div>
            <div class="ObjectsPreviewList__location">{{location}}</div>
        </div>
        <div class="ObjectMapPreview__images">
            <ImageSlider2 v-if="images.length" :images="images" :id="id"/>
            <NoImages v-else></NoImages>
        </div>
        <div class="ObjectMapPreview__info">
            <div class="ObjectMapPreview__header">
                <ObjectPrice v-bind="price" :tp="tp" />
                <ObjectLikeButtonsCompact :status="likeStatus" :id="id" />
            </div>
            <div class="ObjectMapPreview__params">
                <ObjectParams :params="objectSlice(params, 2)"/>
            </div>
            <ObjectMoreInfoLink :id="id"/>
        </div>
    </div>
</template>

<script>
import ImageSlider2 from "@/components/Object/ImageSlider2";
import ObjectPrice from "@/components/Object/ObjectPrice";
import ObjectLikeButtonsCompact from "@/components/Object/ObjectLikeButtonsCompact";
import ObjectMoreInfoLink from "@/components/Object/ObjectMoreInfoLink";
import ObjectParams from "@/components/Object/ObjectParams";
import {objectSlice} from "@/utils/objectSlice";
import NoImages from "@/components/elements/NoImages";

export default {
    name: "ObjectMapPreview",
    components: {
        ImageSlider2,
        ObjectPrice,
        ObjectLikeButtonsCompact,
        ObjectMoreInfoLink,
        ObjectParams,
        NoImages
    },
    props: {
        id: [Number, String],
        name: String,
        location: String,
        images: Array,
        params: Object,
        object: Object,
        price: {
            current: [Number, String],
            prev: [Number, String]
        },
        likeStatus: Number,
        tp: Number
    },
    methods: {
        objectSlice,
    }
}
</script>

<style lang="scss">
.ObjectMapPreview {
  border-top: solid 1px #CED0D6;

  .hooper-pagination {
    bottom: 12px;
  }

  &__images {
    height: 175px;
  }

  &__id {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 12px;
    padding: 4px 12px;
    background-color: $white;
  }

  &__info {
    padding: 16px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
  }

  &__params {
    margin-bottom: 8px;

    .ObjectParams__item {

      & + .ObjectParams__item {
        margin-top: 8px;
      }
    }
  }
}

.ObjectsPreviewList {
    display: flex;
    flex-direction: column;
    max-height: 100%;
    position: relative;

    &__name {
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        padding: 5px;
    }

    &__location {
        font-weight: 300;
        margin-bottom: 12px;
        padding: 5px;
    }
}
</style>